<template>
  <div id="page-user-view">
    <!-- <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert> -->

    <div id="user-data">
      <vx-card
        class="mb-base"
        title="Gerar Relatório Mensal">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label for="">Ano</label> <br />

            <select
              v-model="dataActual"
              class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed">
              <option
                v-for="n in Array.from(
                  { length: 100 },
                  (v, i) => i + (new Date().getFullYear() - 99)
                )"
                :value="n"
                :key="n">
                {{ n }}
              </option>
            </select>
          </div>

          <div>
            <label for="">Mês</label> <br />
            <v-select
              v-validate="'required'"
              v-model="month"
              :reduce="options => options.id"
              :options="[
                { id: 1, label: 'Janeiro' },
                { id: 2, label: 'Fevereiro' },
                { id: 3, label: 'Março' },
                { id: 4, label: 'Abril' },
                { id: 5, label: 'Maio' },
                { id: 6, label: 'Junho' },
                { id: 7, label: 'Julho' },
                { id: 8, label: 'Agosto' },
                { id: 9, label: 'Setembro' },
                { id: 10, label: 'Outubro' },
                { id: 11, label: 'Novembro' },
                { id: 12, label: 'Dezembro' }
              ]">
            </v-select>
          </div>

          <div>
            <label for="">Tamanho da folha</label> <br />

            <v-select
              :options="['A2', 'A3', 'A4']"
              v-model="paperSize"></v-select>
          </div>

          <div>
            <label for=""></label> <br />
            <vs-button
              class="w-full"
              color="primary"
              iconPack="feather"
              icon="icon-printer"
              @click="getRelatorio"
              >Gerar</vs-button
            >
          </div>

          <div v-if="down == true">
            <label for=""></label> <br />
            <vs-button
              @click="down = false"
              v-if="relatorio"
              class="w-full"
              color="success"
              iconPack="feather"
              icon="icon-download"
              target="_blank"
              :href="relatorio"
              >Download</vs-button
            >
          </div>

          <!-- <div class="vx-col w-1/6  mb-5" >
             <label for=""></label> <br>
              <vs-button  class="w-full" color="primary"  @click="saveMarcar">
                Marcar
              </vs-button>

          </div> -->
        </div>
        <!-- Avatar -->
        <div>
          <!-- <h5 class="mb-5"><input  type="checkbox" style=" height: 20px; width: 20px;" >  Selecione colunas</h5> -->
          <vs-checkbox
            v-if="down == false"
            class="mt-5"
            v-model="checkBox1"
            >Escolher colunas</vs-checkbox
          >
        </div>
        <div
          v-if="checkBox1 == true"
          class="form-group form-check">
          <div class="vx-row">
            <div
              class="vx-col w-1/2 mb-1"
              v-for="item in Items"
              v-bind:key="item.id">
              <input
                type="checkbox"
                style="height: 20px; width: 20px"
                v-model="fruitCollection"
                :id="item"
                :value="item" />
              <label
                class="form-check-label text-sm ml-5"
                :for="item.id"
                >{{ item }}</label
              >
            </div>
          </div>
        </div>
      </vx-card>

      <!-- <vx-card title="">
        <vs-divider></vs-divider>
        <div class="block overflow-x-auto">



<vs-table  stripe v-model="selected" pagination :max-items="quant" search :data="employees">
<template  slot="header">
          <v-select
             :options="['5','10','20','50']"
             v-model="quant"
              >
              </v-select>
          </template>
    <template slot="thead">
      <vs-th sort-key="name">Nome</vs-th>
      <vs-th sort-key="surname">Apelido</vs-th>
      <vs-th sort-key="entry_date">Data e Hora de entrada</vs-th>
      <vs-th sort-key="entry_date">Observação</vs-th>
      <vs-th></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

        <vs-td :data="data[indextr].name">
          {{ data[indextr].name }}
        </vs-td>

        <vs-td :data="data[indextr].surname">
          {{ data[indextr].surname }}
        </vs-td>

        <vs-td :data="data[indextr].entry_date">
          {{ data[indextr].entry_date }}
        </vs-td>

        <vs-td :data="data[indextr].note">
          {{ data[indextr].note }}
        </vs-td>
<vs-td>
   <vs-td class="whitespace-no-wrap" :data="data[indextr].id">

                    <vs-button v-if="data[indextr].note!='presente'" color="success" size="small"  type="border" @click="openJustificar(tr)"> Justificar</vs-button>

            </vs-td>
</vs-td>
      </vs-tr>
    </template>
  </vs-table>


        </div>
        <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto  mt-2" type="border" color="warning"  @click="clean">Limpar</vs-button>
          <vs-button class="ml-4 mt-2" @click="saveMarcar" >Marcar</vs-button>
        </div>
      </div>
    </div>



      </vx-card> -->
    </div>
  </div>
</template>

<script>
  import http from '../../../../../http-common';
  import vSelect from 'vue-select';
  export default {
    components: {
      vSelect
    },
    data() {
      return {
        Items: [],

        fruitCollection: [],

        ////////////////////////////////

        components: [],
        dataEntrada: '',
        dataSaida: '',
        estado: '',
        quant: 10,
        users: [],
        selectedUser: '',
        permission_name: [],
        role_name: [],
        popupJustificar: false,
        err: '',
        employees: [],
        popupUpBaixar: false,
        exit_date: '',
        exit_time: '',
        paperSize: 'A4',
        //////////////permissoes//////////////
        canListEmp: false,
        canAddEmp: false,
        canUpdateEmp: false,
        canDeleteEmp: false,
        canApproveEmp: false,
        checkBox1: false,

        //////////////Roles////////////////////
        roleFuncionario: false,
        roleGestorFuncionario: false,
        roleGestorAssiduidade: false,
        roleGestorlicencas: false,
        roleGestorRemuneracoes: false,
        roleGestorHst: false,
        roleGestorUtilizadores: false,
        roleAdministrador: false,
        roleGestorSuperAdministrador: false,
        result: [],
        employee_id: [],
        attendance_id: [],
        entry_date: '2022-03-29',
        note: '',
        attachment: '',
        falta: [],
        description: '',
        selected: [],
        dataActual: '',
        relatorio: '',
        down: false,
        month: '',
        tableList: [
          'vs-th: Component',
          'vs-tr: Component',
          'vs-td: Component',
          'thread: Slot',
          'tbody: Slot',
          'header: Slot'
        ]
      };
    },

    mounted() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.getData();

        // this.getRelatorio();
      },

      clean() {
        (this.exit_date = ''), (this.exit_time = '');
      },

      handleSubmit() {
        alert(JSON.stringify(this.fruitCollection));
      },

      getData() {
        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          }
        };

        http
          .get('/salaries/payrollSheet-columns', config)
          .then(result => {
            this.Items = result.data.Columns.reverse();

            //  this.Items= this.components.map(col => ({ name: col.name }));
          })
          .catch(error => {
            error;

            if (error.response.status == 401) {
              this.$router.push('/').catch(() => {});
            }
          });
      },
      getRelatorio() {
        this.$vs.loading();

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          },
          params: {
            month: this.month,
            year: this.dataActual,
            selectedColumns: this.fruitCollection,
            paperSize: this.paperSize,
            type: 1
          }
        };

        http
          .get('salaries/payrollSheet', config)
          .then(result => {
            this.relatorio = result.data;
            (this.down = true), this.$vs.loading.close();
          })
          .catch(error => {
            this.err = error.response.data;
            this.$vs.loading.close();
            this.$vs.notify({
              title: 'Erro',
              text: this.err,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'top-right'
            });

            if (error.response.status == 401) {
              this.$router.push('/').catch(() => {});
            }
          });
      }
    }
  };
</script>

<style lang="scss">
  #avatar-col {
    width: 10rem;
  }

  #page-user-view {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: 0.8rem;
        word-break: break-all;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width: 370px) {
            display: block;
          }
        }
      }
    }
  }

  // #account-info-col-1 {
  //   // flex-grow: 1;
  //   width: 30rem !important;
  //   @media screen and (min-width:1200px) {
  //     & {
  //       flex-grow: unset !important;
  //     }
  //   }
  // }

  @media screen and (min-width: 1201px) and (max-width: 1211px),
    only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }

    // #account-manage-buttons {
    //   width: 12rem !important;
    //   flex-direction: column;

    //   > button {
    //     margin-right: 0 !important;
    //     margin-bottom: 1rem;
    //   }
    // }
  }
</style>
